var initializeHeroBlock = function(block){

	jQuery('button.sound', block).on('click', function(){
		
		var video = jQuery('video', block);
		var muted = video.attr('muted');
		
		if(typeof muted !== 'undefined' && muted !== false) {
			video.removeAttr('muted');
			video.prop('muted', false);
			video[0].volume = 0.5;
		} else {
			video.attr('muted', 'muted');
			video.prop('muted', true);
			video[0].volume = 0;
		}
		
		jQuery(this).toggleClass('muted');
		
	});

}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-hero').each(function(){
		initializeHeroBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=hero', initializeHeroBlock);
